import Name from './Name';
import OrgByClass from './OrgByClass';
import IsEval from './IsEval';
import IsEvalMutual from './IsEvalMutual';
import NameCheck from './NameCheck';

export default {
    Name,
    IsEval,
    IsEvalMutual,
    NameCheck,
    OrgByClass
}